import { isValidProfession } from "./registrationWizardValidation";
import { normalizeProfessionTitle } from "./registrationWizardPrefill";

export const WIZARD_STEP_IDS = {
  WELCOME_INTRO: "welcome_intro",
  NAME: "name",
  SECURITY: "security",
  CLINICAL: "clinical",
  CLINIC: "clinic",
  PHOTO: "photo",
  ABOUT: "about",
};

export const shouldSkipSecurityStep = (account = {}) => {
  const needPassword = account.needToSetPassword !== false;
  const termsAccepted = account.termsAndConditionsAccepted === true;
  return !needPassword && termsAccepted;
};

export const needsPasswordOnSecurityStep = (account = {}) => account.needToSetPassword !== false;

export const needsTermsOnSecurityStep = (account = {}) => account.termsAndConditionsAccepted !== true;

export const hasNameOnFile = (account = {}) => {
  const firstName = String(account.firstName || "").trim();
  const lastName = String(account.lastName || "").trim();
  return Boolean(firstName && lastName);
};

export const hasProfilePhotoOnFile = (account = {}, stepPhoto = null) => {
  if (stepPhoto?.file || stepPhoto?.existing) {
    return true;
  }
  if (stepPhoto?.dataUrl && !stepPhoto?.file) {
    return true;
  }
  return Boolean(account.profilePhotoUrl || account.hasProfilePhotoOnFile);
};

export const shouldSkipNameStep = (account = {}, stepPhoto = null) =>
  hasNameOnFile(account) && hasProfilePhotoOnFile(account, stepPhoto);

export const parseProfessionsFromApi = (data) => {
  const list = data?.professions || (Array.isArray(data) ? data : []);
  const first = Array.isArray(list) ? list[0] : null;
  if (!first) return null;

  const profession = normalizeProfessionTitle(first.profession || first.title);
  if (!isValidProfession(profession)) return null;

  return {
    profession,
    experienceSince: first.experienceSince ? String(first.experienceSince) : "",
  };
};

export const buildStepPipeline = (account = {}, stepPhoto = null) => {
  const pipeline = [WIZARD_STEP_IDS.WELCOME_INTRO];

  if (!shouldSkipNameStep(account, stepPhoto)) {
    pipeline.push(WIZARD_STEP_IDS.NAME);
  }

  if (!shouldSkipSecurityStep(account)) {
    pipeline.push(WIZARD_STEP_IDS.SECURITY);
  }
  if (!account.hasProfessionOnFile) {
    pipeline.push(WIZARD_STEP_IDS.CLINICAL);
  }

  pipeline.push(
    WIZARD_STEP_IDS.CLINIC,
    WIZARD_STEP_IDS.PHOTO,
    WIZARD_STEP_IDS.ABOUT
  );

  return pipeline;
};
